import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const PORTRAIT = 'https://cdn.magicpatterns.com/uploads/pB9gorEFzofZX96xhoHuNx/telegram-cloud-document-2-5386561911775076958.jpg';
export function ClassicFounder() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="about" className="relative py-20 lg:py-28 bg-navy-50/50 overflow-hidden" data-id="element-644" data-mp="kob32oo6v1ev">
      <div className="absolute inset-0 pointer-events-none" data-id="element-645" data-mp="zdfnmcighhq5">
        <div className="absolute top-20 left-0 w-[400px] h-[400px] rounded-full bg-primary-100/20 blur-3xl hidden sm:block" data-id="element-646" data-mp="ueci6qykd9hn" />
        <div className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full bg-cyan-100/15 blur-3xl hidden sm:block" data-id="element-647" data-mp="18fgi51mb1po4" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-648" data-mp="14b8r2xsdjxmq">
        <div className="grid lg:grid-cols-5 gap-10 lg:gap-16 items-center" data-id="element-649" data-mp="1qa8a680rz93l">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6
        }} className="lg:col-span-2" data-id="element-650" data-mp="1qcax2j6msm43">
            <div className="relative max-w-sm mx-auto lg:mx-0" data-id="element-651" data-mp="257h4naldkszj">
              <div className="aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl shadow-navy-900/25" data-id="element-652" data-mp="256z9khag8kt7">
                <img src={PORTRAIT} alt={`${c.founder.name} — ${c.founder.role}`} className="w-full h-full object-cover object-top" loading="lazy" data-id="element-653" data-mp="2979h3ydw3ja6" />
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="lg:col-span-3" data-id="element-654" data-mp="2nzjmgp9r6fbd">
            <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-655" data-mp="1y9ut07tfkzyz">
              {lang === 'EN' ? 'Founder' : 'Засновник агентства'}
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold text-navy-900 tracking-tight leading-[1.1]" data-id="element-656" data-mp="2d0txp7r5b4da">
              {c.founder.title}
            </h2>

            <div className="mt-7 pb-7 border-b border-navy-200" data-id="element-657" data-mp="2lxugmyvg4a9c">
              <p className="text-xl font-bold text-navy-900" data-id="element-658" data-mp="2h142wi745qr3">
                {c.founder.name}
              </p>
              <p className="mt-1 text-[0.9375rem] text-primary-600 font-medium" data-id="element-659" data-mp="2vwk374yaeivx">
                {c.founder.role}
              </p>
            </div>

            <div className="mt-7 space-y-4" data-id="element-660" data-mp="2qwny12dusles">
              {c.founder.paragraphs.map((p, i) => <p key={i} className={i === 0 ? 'text-lg font-semibold text-navy-800 leading-relaxed' : 'text-base text-navy-500 leading-relaxed'} data-id="element-661" data-mp="11lezy1r448h4" data-mpi={i}>
                  {p}
                </p>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}